import { render, staticRenderFns } from "./WycContent.vue?vue&type=template&id=4f0e90c7&scoped=true&"
import script from "./WycContent.vue?vue&type=script&lang=js&"
export * from "./WycContent.vue?vue&type=script&lang=js&"
import style0 from "./WycContent.vue?vue&type=style&index=0&id=4f0e90c7&lang=less&scoped=true&"
import style1 from "./WycContent.vue?vue&type=style&index=1&id=4f0e90c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0e90c7",
  null
  
)

export default component.exports